// Form field widths and styling constants
export const FORM_CONSTANTS = {
  FIELD_WIDTH: "480px",
  SIGNATURE_HEIGHT: "100px",
  MAX_MODAL_WIDTH: "500px",
  MODAL_WIDTH: "90%",
  MAX_MODAL_HEIGHT: "90vh",
};

// Validation messages
export const VALIDATION_MESSAGES = {
  NO_REVISION: "No revision selected!",
  PASSWORD_REQUIRED: "Password is mandatory.",
  SIGNATURE_REQUIRED: "Signature is mandatory.",
  REVISION_DETAILS_REQUIRED: "Revision Details are mandatory.",
  USER_SELECTIONS_REQUIRED: "User selections are required.",
  TEMPLATE_REQUIRED: "Please select a template.",
  AT_LEAST_ONE_APPROVER: "At least one approver is required.",
  CURRENT_REVISION_NOT_FOUND: "Current revision not found!",
};

// Success messages
export const SUCCESS_MESSAGES = {
  REVISION_CREATED: "Revision created successfully!",
};

// User purposes
export const USER_PURPOSES = {
  SUBMIT: "Submit",
  APPROVE: "Approve",
  RELEASE: "Release",
};

// Revision status
export const REVISION_STATUS = {
  NOT_SUBMITTED: "Not Submitted",
  RELEASED: "released",
};

// Modal modes
export const MODAL_MODES = {
  CREATE: "create",     // Used in Documents - copies from existing revision
  DRAFT: "draft",       // Used in AddProcedure - uses templates
};

